"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationLabels = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const center_1 = __importDefault(require("@turf/center"));
const react_maps_1 = require("@yanzi/react-maps");
const site_1 = require("@yanzi/site");
const react_1 = require("react");
const __1 = require("../..");
const LocationLabels = function LocationLabels(_a) {
    var { locationId, floorLevel } = _a, props = __rest(_a, ["locationId", "floorLevel"]);
    const geoJsonIdToText = __1.useGeoJsonIdToAssetDictionary(locationId, floorLevel);
    const assetToText = __1.useAssetToLabelText(locationId, floorLevel);
    const renderFeature = react_1.useCallback(({ feature, props }) => {
        const id = feature.id;
        if (!id) {
            return null;
        }
        const did = geoJsonIdToText[id];
        if (!did) {
            return null;
        }
        const text = assetToText[did];
        if (!text) {
            return null;
        }
        return jsx_runtime_1.jsx(LabelFeature, Object.assign({ feature: feature, text: text }, props), feature.id);
    }, [assetToText, geoJsonIdToText]);
    const layerFilter = react_1.useCallback(x => { var _a, _b; return !!((_b = (_a = x.contentType) === null || _a === void 0 ? void 0 : _a.includes) === null || _b === void 0 ? void 0 : _b.call(_a, 'json')); }, []);
    return (jsx_runtime_1.jsx(site_1.SiteMapFloorPlans, Object.assign({ floorLevel: floorLevel, renderMode: "vector", layerFilter: layerFilter, renderFeature: renderFeature }, props), void 0));
};
exports.LocationLabels = LocationLabels;
function LabelFeature(_a) {
    var { feature } = _a, props = __rest(_a, ["feature"]);
    const memoized = react_maps_1.useMemoized(feature);
    const midPoint = react_1.useMemo(() => {
        var _a;
        try {
            return (_a = center_1.default(memoized)) !== null && _a !== void 0 ? _a : memoized;
        }
        catch (e) {
            console.error(e);
            return memoized;
        }
    }, [memoized]);
    return (jsx_runtime_1.jsx(react_maps_1.GeoJSONFeature, Object.assign({ backgroundColor: "transparent", borderColor: "transparent", textBackgroundColor: "rgba(0,0,0,0.8)", color: "#fff", textOffsetY: -10, declutter: true }, props, { feature: midPoint }), void 0));
}
//# sourceMappingURL=index.js.map